import { createContext, useContext, useEffect, useState } from "react";
import { adminApi } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    (async () => {
      const token = localStorage.getItem("rc_admin_token");
      if (token) {
        try {
          const { data } = await adminApi.get("/auth/me");
          setAdmin(data);
        } catch {
          localStorage.removeItem("rc_admin_token");
        }
      }
      setReady(true);
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await adminApi.post("/auth/login", { email, password });
    localStorage.setItem("rc_admin_token", data.token);
    setAdmin({ email: data.email, name: data.name, scopes: data.scopes });
    return data;
  };

  const logout = () => {
    localStorage.removeItem("rc_admin_token");
    setAdmin(null);
  };

  return <AuthContext.Provider value={{ admin, ready, login, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
